/* eslint-disable @typescript-eslint/ban-ts-comment */
import type { Store } from 'mipd';
import { metaMask } from 'wagmi/connectors';

import type { WalletAdapter } from '../../types';
import { isProviderExistsEIP6963 } from '../../utils';
import { getDevice } from '../../utils';
import { Icon } from './icon';

export const metaMaskId = 'metaMask';
export const metaMaskName = 'MetaMask';
export const metaMaskRdns = 'io.metamask';

const device = getDevice();

const currentHref = globalThis.window
  ? globalThis.window.location.hostname + globalThis.window.location.pathname // encoding not supported
  : '';

const getMetaMaskConnector = () => metaMask({ extensionOnly: true });

const detector = (providersStore: Store) => {
  if (device.isMobile || device.isTablet) {
    return (
      isProviderExistsEIP6963(providersStore, metaMaskRdns) ||
      Boolean(globalThis.window?.ethereum?.isMetaMask || globalThis.window?.ethereum?.providerMap?.has?.('MetaMask'))
    );
  }

  return true;
};

type Params = {
  providersStore: Store;
};

export const MetaMask: WalletAdapter = ({ providersStore }: Params) => ({
  walletName: metaMaskName,
  walletId: metaMaskId,
  type: metaMask.type,
  Icon,
  detector: () => detector(providersStore),
  deeplink: `https://metamask.app.link/dapp/${currentHref}`,
  getConnector: getMetaMaskConnector,
});
